import { useMediaQuery } from "@material-ui/core";

export function useIsMobile(): boolean {
    const isMobile = useMediaQuery('(max-width: 750px)');
    return isMobile;
}

export function useIsDesktop(): boolean {
    const isDesktop = useMediaQuery('(min-width: 1280px)');
    return isDesktop;
}

export function useIsTablet(): boolean {
    const isTablet = useMediaQuery('(min-width: 751px) and (max-width: 1279px)');
    return isTablet;
}
